<mat-card-content class="card-document mat-elevation-z2" [fxLayoutGap]="'2px'">
  <form [formGroup]="documentForm" [fxLayoutGap]="'2px'">
    <!-- Nature / DUA déjà remplie -->
    <ng-container *ngIf="document?.dua_obj?.nature">
      <div class="nature_title" fxLayout="column" fxLayoutAlign="center center">
        <p>
          <span class="title">Nature actuelle du document : </span> <strong>{{ document?.dua_obj?.nature }}</strong>
          <br/><span class="title">Catégorie : </span><span>{{ getCategorieValue() }}</span>
        </p>
      </div>
    </ng-container>
    <!-- sélection filtre sur catégorie puis nature / DUA -->
    <div fxLayoutAlign="center center" style="padding-bottom: 10px;">
      <mat-error *ngIf="documentForm.controls.duaSelected.errors">
        <div *ngIf="documentForm.controls.duaSelected.hasError('required')">
          Veuillez choisir une nature de document pour la DUA
        </div>
      </mat-error>
    </div>

    <p class="mat-caption mat-hint">Choisir la nature par filtrage en cliquant sur le champ</p>

    <div>
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Sélectionner une nature</mat-label>
        <input type="text" placeholder="Filtrer les natures" matInput [matAutocomplete]="autoNature"
               [formControl]="ctrlFilterDua" data-cy="input-document-edit-filtrer-natures">
        <mat-autocomplete #autoNature="matAutocomplete" (optionSelected)="onSelectNature($event.option.value)">
          <mat-option *ngFor="let dua of filteredDuas$ | async" [value]="dua" [matTooltip]="showDua(dua)"
                      matTooltipClass="tooltipDua" [attr.data-cy]="'opt-document-edit-'+dua.nature">
            {{ dua.nature }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <p class="mat-caption" style="font-weight: bold;">- OU -</p>

    <p class="mat-caption mat-hint">Choisir la catégorie en cliquant sur le champ et ensuite sélectionner la nature du
      document pour en déduire sa DUA et son sort final</p>

    <div class="dua" fxLayout="row" fxLayoutAlign="space-around center">
      <div class="lft" fxLayout="column" fxLayoutAlign="center center">
        <mat-form-field appearance="outline" matBadge="1" matBadgePosition="before" matBadgeColor="accent">
          <mat-label><span class="mandatory-field">* </span><b>Catégorie du document</b></mat-label>
          <input type="text"
                 matInput
                 placeholder="Choisir la catégorie du document"
                 (click)="selectCat()"
                 [value]="categoryName">
        </mat-form-field>
        <ng-container *ngIf="duasFiltered?.length > 0">
          <div class="ho-div">
            <mat-icon>arrow_downward</mat-icon>
          </div>
          <div>
            <mat-form-field appearance="outline" matBadge="2" matBadgePosition="before" matBadgeColor="accent">
              <mat-label><span class="mandatory-field">* </span><b>Nature du document</b></mat-label>
              <input type="text"
                     matInput
                     placeholder="Choisir la nature du document"
                     [matTooltip]="getNatureValue()" [matTooltipClass]="'tooltip'"
                     (click)="duaFilter.patchValue(null)"
                     [formControl]="duaFilter"
                     [matAutocomplete]="auto">
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onDuaSelected(parseInt($event.option.id))">
                <mat-option *ngFor="let dua of filteredOptions$ | async" [value]="dua.nature" [id]="dua.id.toString()"
                            [matTooltip]="dua?.nature"
                            [matTooltipClass]="'tooltip'">
                  {{ dua?.nature }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
        </ng-container>
      </div>
      <div fxLayout="column" fxLayoutAlign="center center" class="center-div">
        <mat-icon>arrow_forward</mat-icon>
      </div>
      <div class="rgt" fxLayout="column" fxLayoutAlign="center center">
        <mat-form-field appearance="outline">
          <mat-label><b>DUA</b></mat-label>
          <input type="text"
                 [disabled]="true"
                 matInput
                 [value]="depositSvc.displayDUA(document?.dua_obj?.duration)"
                 readonly data-cy="input-document-edit-dua"
          />
        </mat-form-field>
        <div class="ho-div">&nbsp;</div>
        <mat-form-field appearance="outline">
          <mat-label><b>Sort final</b></mat-label>
          <input type="text"
                 [disabled]="true"
                 [matTooltip]="depositSvc.displayConservationDefault(document?.dua_obj?.final_fate)"
                 matInput [value]="depositSvc.displayConservationDefault(document?.dua_obj?.final_fate)"
                 readonly data-cy="input-document-edit-final-fate"
          />
        </mat-form-field>

      </div>
    </div>

    <ng-container *ngIf="!forceEdit">
      <div [fxLayoutGap]="'2px'">
        <p class="mat-caption mat-hint">L'année de création du document et optionnellement sa description</p>
        <div fxLayout="row" fxLayoutAlign="space-around center">
          <mat-form-field appearance="outline">
            <mat-label><span class="mandatory-field">* </span><b>Année de création</b></mat-label>
            <input type="text"
                   maxlength="4"
                   matTooltip="Année de création du document (exemple: 2019)"
                   formControlName="creationYear"
                   matInput placeholder="Année de création du document (exemple : 2019"
                   data-cy="input-document-edit-creation-year"/>
            <mat-error *ngIf="documentForm.controls.creationYear.errors">
              <div *ngIf="documentForm.controls.creationYear.hasError('numeric')">
                l'année doit être un nombre
              </div>
              <div *ngIf="documentForm.controls.creationYear.hasError('pattern')">
                l'année doit être un nombre conforme entre 1900 et 2099 (exemple : 1990, 2019, ...)
              </div>
              <div *ngIf="documentForm.controls.creationYear.hasError('required')">
                l'année est obligatoire
              </div>
            </mat-error>
          </mat-form-field>
          <div class="center-div">&nbsp;</div>
          <mat-form-field appearance="outline">
            <mat-label>Description</mat-label>
            <textarea matInput formControlName="description" rows="1" placeholder="Description du document"
                      data-cy="txtarea-document-edit-description"></textarea>
          </mat-form-field>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="!forceEdit">
      <div fxLayoutAlign="end center" style="padding-bottom: 5px;">
        <button mat-raised-button type="button" color="primary" matTooltip="Suppression du document"
                class="document_del"
                (click)="delDocument()" data-cy="btn-document-edit-delete">
          <mat-icon>delete</mat-icon>
        </button>
      </div>
    </ng-container>
  </form>
</mat-card-content>
